/* eslint-disable import/named */
import { NuxtAxiosInstance } from 'vue/types/vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import { AxiosRequestConfig } from 'axios';
import { CdnWithUrl, RequestSource, ResponseBase } from './base';

import axios from './request';

export enum AIFeedLiked {
    UnLike = 0,
    Like = 1,
}

export enum AIAuthorFollowing {
    Unfollowed = 0,
    Following = 1,
}

interface AIForwardStatsParams {
    fid?: string;
    et?: string;
}

export interface AIFeed {
    bot_id_str?: string;
    bot_name?: string;
    bot_text?: string;
    bot_introduction?: string;
    head_url?: string;
    bg_url?: string;
    bot_first_line_url: string;
    // extra
    conversation_id?: string;
    index: number;
    liked?: AIFeedLiked;
    // below backup
    web_feed_type?: string;
    time?: string;
    timestamp?: number;
    following?: AIAuthorFollowing;
    photo_id?: number;
    photo_id_str?: string;
    user_name?: string;
    user_sex?: string;
    kwai_id?: string;
    user_text?: string;
    comment_count?: number;
    forward_count?: number;
    download_count?: number;
    headurls?: Array<CdnWithUrl>;
    main_mv_urls?: Array<CdnWithUrl>;
    transcode_manifest_info?: any; // 265 播放器视频源信息，优先取这个字段，用 main_mv_urls 兜底
    cover_thumbnail_urls?: Array<CdnWithUrl>;
    cover_first_frame_urls?: Array<CdnWithUrl>;
    reco_reason?: string;
    exp_tag?: string;
    ext_params?: Record<string, any>;
    like_count?: number;
    view_count?: number;
    forward_stats_params?: AIForwardStatsParams;
    caption?: string;
    user_id?: number | string;
    user_id_str?: string;
    verifiedNum?: number;
    google_ad?: boolean;
    source_type?: string; // 后续添加其他来源， 目前只识别 'reco'
    audioSrc?: string;
}

/** *** Api  *** */
interface AIFeedListRequest {
    botId?: string;
    count?: number;
    request_source?: RequestSource;
    mobile?: boolean;
}

interface AIFeedListResponse extends ResponseBase {
    feeds?: Array<AIFeed>;
}

interface ChangeAIFeedLikedStatusRequest {
    fromPage?: string;
    cancel?: boolean;
    botId?: string;
}

type ChangeAIFeedLikedStatusResponse = ResponseBase;

interface AIFollowActionRequest {
    fromPage?: string;
    toUid?: string | number; // 可以是 user_id, 也可以是 `@${kwai_id}`
    fType?: number;
    photoId?: string;
    noticeId?: string;
}

type AIFollowActionResponse = ResponseBase;

export class AIFeedApiService {
    private $axios?: NuxtAxiosInstance;

    constructor() {
        this.$axios = axios;
    }

    async getFeedList(data: AIFeedListRequest, config?: AxiosRequestConfig) {
        const res = await this.$axios?.$$post?.<AIFeedListResponse>('/rest/o/w/pwa/aifeed/slides', data, config);

        return res;
    }

    async changeAIFeedLikedStatus(data: ChangeAIFeedLikedStatusRequest, config?: AxiosRequestConfig) {
        const res = await this.$axios?.$$post?.<ChangeAIFeedLikedStatusResponse>('/rest/o/w/pwa/likeAction', data, config);

        return res;
    }

    async followAction(data: AIFollowActionRequest, config?: AxiosRequestConfig) {
        const res = await this.$axios?.$$post?.<AIFollowActionResponse>('/rest/o/w/pwa/followAction', data, config);

        return res;
    }
}

export const AIFeedApi = new AIFeedApiService();
